/** PL approved the four existing Achernar recordings for connection on 2026-09-09.
 * These are bundled files, not a synthesis/recognition provider or runtime fallback. */
export const STATE_VOICE_BASE = '/assets/audio/lt-state-achernar/';
export const STATE_VOICE_ASSETS = Object.freeze({
  'state-acknowledge': { publicUrl: `${STATE_VOICE_BASE}acknowledge.mp3`, durationMs: 1512, transcript: '응, 들었어!' },
  'state-praise': { publicUrl: `${STATE_VOICE_BASE}praise.mp3`, durationMs: 2808, transcript: '좋아! 아주 잘했어.' },
  'state-retry': { publicUrl: `${STATE_VOICE_BASE}retry.mp3`, durationMs: 4656, transcript: '괜찮아. 지나쌤과 천천히 한 번 더 해보자.' },
  'state-wait-reassure': { publicUrl: `${STATE_VOICE_BASE}wait-reassure.mp3`, durationMs: 4272, transcript: '천천히 해도 괜찮아. 지나쌤이 기다릴게.' },
} as const);
// Actual approved silent MODEL clip is four seconds; it demonstrates ONE finger only.
export const ONE_MODEL_VIDEO_MS = 4000;

/** PL rejected the first gap-only edit as “하낫 둘”. Do not use that asset.
 * Preserve D1-22's introductory sentence (0–4.65 s), then whole isolated ONE from
 * D1-12 (8–8.76 s) and TWO from D1-13 (0.84–1.50 s), with a 300 ms extra gap.
 * Each excerpt includes silence before/after the complete word. No mid-word splice,
 * synthesis, pitch/rate change or original overwrite. V2 pronunciation awaits PL listening. */
export const TWO_MODEL_PACED_ASSET = Object.freeze({
  publicUrl: `${STATE_VOICE_BASE}model-two-separated-v2.wav`, durationMs: 6370,
  transcript: '이번엔 사과가 몇 개일까? 쌤이랑 같이 세어볼까? 하나, 둘!',
});

export const STATE_AUDIO_CUES = {
  ACKNOWLEDGE: 'state:acknowledge',
  PRAISE: 'state:praise',
  RETRY: 'state:retry',
  WAIT: 'state:wait-reassure',
  MODEL_TWO_PACED: 'state:model-two-paced',
} as const;

export const STATE_VOICE_MANIFEST = Object.freeze({
  [STATE_AUDIO_CUES.ACKNOWLEDGE]: Object.freeze({
    cueId: STATE_AUDIO_CUES.ACKNOWLEDGE,
    kind: 'CORRECT' as const,
    publicUrl: `${STATE_VOICE_BASE}acknowledge.mp3`,
    mime: 'audio/mpeg' as const,
    durationMs: 1512,
  }),
  [STATE_AUDIO_CUES.PRAISE]: Object.freeze({
    cueId: STATE_AUDIO_CUES.PRAISE,
    kind: 'CORRECT' as const,
    publicUrl: `${STATE_VOICE_BASE}praise.mp3`,
    mime: 'audio/mpeg' as const,
    durationMs: 2808,
  }),
  [STATE_AUDIO_CUES.RETRY]: Object.freeze({
    cueId: STATE_AUDIO_CUES.RETRY,
    kind: 'WRONG' as const,
    publicUrl: `${STATE_VOICE_BASE}retry.mp3`,
    mime: 'audio/mpeg' as const,
    durationMs: 4656,
  }),
  [STATE_AUDIO_CUES.WAIT]: Object.freeze({
    cueId: STATE_AUDIO_CUES.WAIT,
    kind: 'SILENCE' as const,
    publicUrl: `${STATE_VOICE_BASE}wait-reassure.mp3`,
    mime: 'audio/mpeg' as const,
    durationMs: 4272,
  }),
  [STATE_AUDIO_CUES.MODEL_TWO_PACED]: Object.freeze({
    cueId: STATE_AUDIO_CUES.MODEL_TWO_PACED,
    kind: 'TEACHER' as const,
    publicUrl: TWO_MODEL_PACED_ASSET.publicUrl,
    mime: 'audio/wav' as const,
    durationMs: TWO_MODEL_PACED_ASSET.durationMs,
  }),
});

